import { render } from "./CustomerDetailMultiCustomerTab.vue?vue&type=template&id=0dc0cc28&scoped=true"
import script from "./CustomerDetailMultiCustomerTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailMultiCustomerTab.vue?vue&type=script&lang=js"

import "./CustomerDetailMultiCustomerTab.vue?vue&type=style&index=0&id=0dc0cc28&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc0cc28"]])

export default __exports__